module.exports = __webpack_public_path__ + "media/images/gallery/stars/orion/bellatrix-1e26ab65cd21eb8894e841b6bec5f4bf.jpg";